(function () {
  'use strict';

  const STORAGE_KEY = 'slimmr:assessment';

  function clearAssessmentSession() {
    if (window.SlimmrAssessment?.clearSession) {
      window.SlimmrAssessment.clearSession();
      return;
    }

    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
  }

  function hasIneligibleSession() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      return saved.ineligible === true;
    } catch (_) {
      return false;
    }
  }

  function isHomepageHref(href) {
    if (!href) return false;

    try {
      const url = new URL(href, window.location.origin);
      return url.pathname === '/' || url.pathname === '';
    } catch (_) {
      return href === '/' || href === '';
    }
  }

  function isReturnHomeAction(target) {
    const link = target.closest('a, button');
    if (!link) return false;

    const href = link.getAttribute('href');
    const text = (link.textContent || '').trim().toLowerCase();

    return isHomepageHref(href)
      || text.includes('return to homepage')
      || text === 'home';
  }

  function init() {
    const params = new URLSearchParams(window.location.search);
    if (params.get('ineligible') === '1' || hasIneligibleSession()) {
      clearAssessmentSession();
    }

    document.addEventListener('click', (event) => {
      if (!isReturnHomeAction(event.target)) return;
      clearAssessmentSession();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
